<template>
  <div>
    <DataTable
      :headers="headers"
      :data="societies"
      :items-per-page="10"
      :buttons="buttons"
      :tableActions="tableActions"
    >
    </DataTable>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DataTable from "@/components/cards/DataTable.vue";

export default {
  components: {
    DataTable,
  },
  data() {
    return {
      headers: [
        { field: "reference", label: "Référence", class: "" },
        { field: "fullName", label: "Nom complet", class: "" },
        {
          field: "capitalization",
          label: "Capitalisation",
          class: "",
          isAmount: true,
        },
        { field: "city", label: "Ville", class: "" },
        { field: "postalCode", label: "Code postal", class: "" },
        { field: "phoneNumberA", label: "Téléphone (1)", class: "" },
        { field: "phoneNumberB", label: "Téléphone (2)", class: "" },
        { field: "ice", label: "ICE", class: "" },
        { field: "rc", label: "RC", class: "" },
      ],
      buttons: [
        {
          label: "Modifier",
          icon: "bi bi-pencil",
          class: "btn btn-warning",
          action: (society) => {
            this.$router.push({
              name: "societies-edit",
              params: { reference: society.reference },
            });
          },
        },
        {
          label: "Détails",
          icon: "bi bi-info-square",
          class: "btn btn-primary",
          action: (society) => {
            this.$router.push({
              name: "societies-details",
              params: { reference: society.reference },
            });
          },
        },
      ],
      tableActions: [
        {
          title: "Actualiser",
          icon: "bi bi-arrow-clockwise",
          class: "btn btn-secondary",
          action: () => this.refresh(),
        },
        {
          title: "Créer",
          icon: "bi bi-plus-square",
          class: "btn btn-primary",
          action: () => this.$router.push({ name: "societies-create" }),
        },
      ],
    };
  },
  computed: {
    ...mapGetters("society", {
      societies: "getAll",
    }),
  },
  mounted() {
    this.$store.dispatch("society/getAll");
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("society/getAll");
    },
  },
};
</script>
